import CustomLoadBoardRepository from "../repositories/CustomLoadBoardRepository";

export class CustomLoadBoardService {
  static GetCustomLoadBoardsByUser(instance, userId) {
    const repo = new CustomLoadBoardRepository;

    return repo.getCustomLoadBoardsByUser(instance, userId);
  }

  static CreateCustomLoadBoard(instance, payload) {
    const repo = new CustomLoadBoardRepository;

    return repo.createCustomLoadBoard(instance, payload).then();
  }

  static UpdateCustomLoadBoard(instance, payload) {
    const repo = new CustomLoadBoardRepository;

    return repo.updateCustomLoadBoard(instance, payload).then();
  }
}